import {
	Directive,
	DOCUMENT,
	ElementRef,
	HostListener,
	inject,
} from '@angular/core';
import { EventPhase } from '@angular/core/primitives/event-dispatch';

@Directive({
	selector: 'a[vc-link]',
	standalone: false,
})
export class LinkDirective {
	private readonly el = inject(ElementRef);
	private readonly document = inject<Document>(DOCUMENT);

	constructor() {
		this.el.nativeElement.rel = 'noopener noreferrer';
	}

	@HostListener('click', ['$event'])
	clicked(event: Event) {
		let url = this.el.nativeElement.href;
		const target = this.el.nativeElement.target;

		if (!url) {
			return;
		}

		if (
			url.startsWith(this.document.location.origin) &&
			target !== '_blank'
		) {
			url = url.replace(this.document.location.origin, '');
		}

		if (url.startsWith('https://') || url.startsWith('http://')) {
			this.document.defaultView?.open(url, target ?? '_blank');
		}
		if (event.eventPhase !== EventPhase.REPLAY) {
			event.preventDefault();
		}
	}
}
